import React from 'react';
import { SubscriptionShape } from '../../shapes';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import PropTypes from 'prop-types';
import CreditCardComponent from './credit_card';
import PaymentRequestButton from './payment_request_button';
import MobilePaymentRequestButton from './mobile_payment_request_button';
import Waiting from '../../components/waiting';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export default class Subscription extends React.Component {

  static propTypes = {
    subscription: SubscriptionShape,
    onSubscribe: PropTypes.func,
    onResetSubscriptionError: PropTypes.func,
    onPopupMobilePaymentOptions: PropTypes.func,
    onNotifyOnSubscriptionPage: PropTypes.func
  }

  componentDidMount() {
    this.props.onNotifyOnSubscriptionPage();
  }

  render() {
    if (this.props.subscription.get('active')) {
      return this.renderRedirect();
    } else if (this.props.subscription.get('loading')) {
      return this.renderCrunching();
    } else {
      return (
        <div className='subscription'>
          <h2>Unlimited Tacks</h2>
          <p>
            Yep, as many tacks as you want for ${process.env.REACT_APP_SUBSCRIPTION_FEE} per month. Just imagine all those words you'll remember for such a small investment.
          </p>
          { this.renderCard() }
        </div>
      );
    }
  }

  renderCard() {
    const error = this.props.subscription.get('error');
    if (error) {
      return (
        <div className='error'>
          <h4>Hmm. { error.message }</h4>
          <div className='action error'>
            <Link to='#' className='btn btn-dark' onClick={ (e) => { e.preventDefault(); this.props.onResetSubscriptionError() } }>Try Again</Link>
          </div>
        </div>
      )
    } else if (this.props.subscription.get('mobilePaymentSupported')) {
      return (
        <Elements stripe={ stripePromise } >
          <MobilePaymentRequestButton subscription={ this.props.subscription } onSubscribe={ this.props.onSubscribe } onPopupMobilePaymentOptions={ this.props.onPopupMobilePaymentOptions } />
          <CreditCardComponent onSubscribe={ this.props.onSubscribe }/>
        </Elements>
      )
    } else {
      return (
        <Elements stripe={ stripePromise } >
          <PaymentRequestButton onSubscribe={ this.props.onSubscribe } />
          <CreditCardComponent onSubscribe={ this.props.onSubscribe }/>
        </Elements>
      )
    }
  }

  renderCrunching() {
    return(<Waiting />);
  }

  renderRedirect() {
    return (
      <Redirect push to='/subscription/confirmation' />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/index.jsx